<template>
  <div class="app-container">
    <transition name="el-zoom-in-top">
      <div v-show="!showAdd" class="filter-container">
        <el-button v-waves class="filter-item" type="info" icon="el-icon-back" @click="back">{{ $t('table.back') }}</el-button>
        <el-input :placeholder="`用户名称`" v-model="listQuery.name" style="width: 200px;" class="filter-item" @keyup.enter.native="handleFilter"/>
        <!-- <el-select v-model="listQuery.roleId" :placeholder="$t('table.role')" clearable class="filter-item" style="width: 130px">
          <el-option v-for="item in roleList" :key="item.RoleId" :label="item.RoleName" :value="item.RoleId"/>
        </el-select> -->
        <el-button v-waves class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">{{ $t('table.search') }}</el-button>
        <!-- <el-button v-if="calcPermission(permition, 1)" class="filter-item" style="float:right" type="primary" icon="el-icon-edit" @click="addField()">{{ $t('table.add') }}</el-button> -->
      </div>
    </transition>
    <transition name="el-zoom-in-top">
      <div v-show="!showAdd" class="filter-container">
        <el-table
          v-loading="listLoading"
          :key="list.id"
          :data="list"

          fit
          stripe
          highlight-current-row
          style="width: 100%;">
          <el-table-column :label="$t('table.id')" align="center">
            <template slot-scope="scope">
              <span>{{ (scope.$index + 1) + ((listQuery.pageIndex - 1) * listQuery.pageSize) }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="`用户名`" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.UserName }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column :label="`场地名`" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.FieldInfo.Address">{{ scope.row.FieldInfo.Address }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column> -->
          <el-table-column :label="`折扣`" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.Info.Discount">{{ scope.row.Info.Discount }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="`添加时间`" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.Info.AddTime">{{ scope.row.Info.AddTime }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="`到期时间`" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.Info.ExpireTime">{{ scope.row.Info.ExpireTime }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="`修改时间`" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.Info.UpdateTime">{{ scope.row.Info.UpdateTime }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <!-- <el-table-column :label="$t('table.actions')" align="center" class-name="small-padding fixed-width">
            <template slot-scope="scope">
              <el-button v-if="calcPermission(permition, 1)" type="primary" @click="addField(scope.row)">{{ $t('table.edit') }}</el-button>
              <el-button v-if="calcPermission(permition, 2)" type="primary" @click="staff(scope.row)">{{ $t('table.qrystaff') }}</el-button>
            </template>
          </el-table-column> -->
        </el-table>
        <div class="pagination-container">
          <el-pagination v-show="total>0" :current-page="listQuery.pageIndex" :page-sizes="[10,20,50,100]" :page-size="listQuery.pageSize" :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange"/>
        </div>
      </div>
    </transition>
    <div v-show="false">{{ lists }}</div>
  </div>
</template>
<script>
import { qryMemberUser } from '@/api/field'
// import { qryRoleInfo } from '@/api/baseModule'
import waves from '@/directive/waves' // 水波纹指令
export default {
  name: 'UserManage',
  directives: {
    waves
  },
  props: {
    id: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      showAdd: false,
      listQuery: {
        pageIndex: 1,
        pageSize: 10,
        name: null
      },
      listLoading: true,
      list: [],
      permition: 0,
      total: null,
      detail: null
    }
  },
  computed: {
    lists: function() {
      this.qryMember()
      return this.id
    }
  },
  created() {
    // if (this.$store.state.roleInfo) {
    //   this.$store.state.roleInfo.LsList[0].RolePrograms.forEach(item => {
    //     if (this.$route.path === item.ProgramInfo.PgUrl) {
    //       this.permition = item.Permition
    //     }
    //   })
    // } else {
    //   qryRoleInfo({
    //     rId: this.$store.getters.roles.RoleId
    //   }).then(response => {
    //     this.$store.state.roleInfo = response
    //     response.LsList[0].RolePrograms.forEach(item => {
    //       if (this.$route.path === item.ProgramInfo.PgUrl) {
    //         this.permition = item.Permition
    //       }
    //     })
    //   })
    // }
  },
  methods: {
    qryMember() {
      this.listQuery.fieldId = this.id
      qryMemberUser(this.listQuery).then(response => {
        this.listLoading = false
        this.list = response.LsList
        this.total = response.TotalRows
      })
    },
    handleSizeChange(e) {
      this.listQuery.pageSize = e
      this.qryMember()
    },
    handleCurrentChange(e) {
      this.listQuery.pageIndex = e
      this.qryMember()
    },
    handleFilter() {
      this.qryMember()
    },
    addField(detail) {
      this.detail = detail
      this.showAdd = true
    },
    back() {
      this.$emit('back')
    },
    backList1() {
      this.showAdd = false
    }
  }
}
</script>
<style>
</style>
